<div class="section-full small-device  p-tb50">
    <div class="container">
        <div class="section-content">
        
            <!-- TESTIMONIAL 4 START ON BACKGROUND -->   
            <div class="section-content">
                 <div class="section-content p-tb10 owl-btn-vertical-center">
                    <!-- <div class="owl-carousel home-client-carousel-2"> -->
                      <owl-carousel-o [options]="customOptions" class="owl-carousel-1 home-client-carousel-2-1">
                        <ng-template carouselSlide *ngFor = "let client of data">
                          <div class="item">
                              <div class="ow-client-logo">
                                  <div class="client-logo client-logo-media">
                                  <a href="javascript:void(0);"><img src="assets/images/client-logo/{{client.image}}" alt=""></a></div>
                              </div>
                          </div>
                        </ng-template>
                      </owl-carousel-o>
                    <!-- </div> -->
                </div>
            </div>
        </div>
    </div>
</div>